var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.25C7.29 3.25 2.25 8.29 2.25 14.5C2.25 20.71 7.29 25.75 13.5 25.75C19.71 25.75 24.75 20.71 24.75 14.5C24.75 8.29 19.71 3.25 13.5 3.25ZM11.25 20.125L5.625 14.5L7.21125 12.9137L11.25 16.9412L19.7887 8.4025L21.375 10L11.25 20.125Z",
    fill: "#64C1B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.ae8fcbf4ff92d7c8e0a554a18bb03362.svg";
export { ForwardRef as ReactComponent };